import { takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { getJSON } from '../util';


function* fetchDeck({ payload: code }) {
    const current = yield select(state => state.deck && state.deck.code);
    if (code === current) {
        return;
    }

    const deck = yield call(getJSON, `/api/content/deck/${code}`);
    yield put({
        type: 'deck:update',
        payload: deck,
    });
}

export function* root() {
    yield takeLatest('deck:required', fetchDeck);
}



// WEBPACK FOOTER //
// ./app/sagas/deck.js